var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.616 72.616",
    width: 72.616,
    height: 72.616,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.695027160458654,
    y: 11.695027160458654,
    transform: "rotate(45, 36.308, 36.308)",
    fill: "none",
    stroke: "#FFFE1A",
    strokeWidth: 3,
    width: 46.22594567908269,
    height: 46.22594567908269
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFE1A",
    fillRule: "nonzero",
    d: "M0 20.62L0 0L5.69 0Q7.90 0 9 1.22Q10.10 2.45 10.13 4.85L10.13 4.85L10.18 14.50Q10.20 17.54 9.12 19.08Q8.04 20.62 5.54 20.62L5.54 20.62L0 20.62ZM4.15 16.97L4.87 16.97Q6 16.97 6 15.86L6 15.86L6 5.23Q6 4.54 5.89 4.19Q5.78 3.84 5.50 3.72Q5.21 3.60 4.61 3.60L4.61 3.60L4.15 3.60L4.15 16.97Z",
    transform: "translate(31.22, 23)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79cbc71f.svg";
export { ForwardRef as ReactComponent };